<template>
<!-- 插入广告列表 -->
  <div  class="More-main">
      <h2 class="title">更多推荐</h2>
      <a class="link" href="javascropt:void(0);"  @click="$router.push('/measurement_list')">点击这里查看“限时免费”测评，看看有没有你感兴趣的吧。</a>

  </div>
</template>

<script>
import { ad} from '@/api/measurement'
export default {
    data(){
        return{
        }
    },
    methods:{
        pullData(){
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss">
.More-main{
    box-shadow: 0px 1px 8px 2px rgba(235, 80, 50, 0.14);
    border-radius: 12px;
    padding: 30px;
    .title{
        margin-bottom: 30px;
        font-size: 36px;
        color: #333333;
        text-align:center;
    }
    .link{
        font-size:28px;
        color:#EB5032;
        text-decoration: underline;
    }
    ul{
        display: flex;
        flex-direction: column;
        li{
            display: flex;
            img{
                width: 282px;
                height: 176px;
                margin-right: 20px;
            }
            .flex-text{
                flex: 1;
                h3{   
                    font-weight: bold;
                    font-size: 32px;
                    line-height: 40px;
                    text-align: left;
                    color: #333333;
                }
                a{
                    display: block;
                    border-radius: 25px;
                    background-color: #EB5032;
                    color: #ffffff;
                    width: 188px;
                    line-height: 50px;
                    margin-top: 15px;
                    font-size: 26px;
                    text-align: center;
                }
            }
            
        }
    }
}
</style>